document.addEventListener('DOMContentLoaded', function () {
    let relatedProductsContainer = document.querySelector('cc-fetched-content');
    let filterContainer = document.querySelector('div[data-ajax-container]');

    console.log("Prefetch Timeouit is: " + window.theme.settings.prefetchCachePeriod);

    let preloadedHTML = {};
    let initialUrl = getPathWithoutQuery(window.location);
    let lastReferrer = document.referrer;

    function getPathWithoutQuery(url) {
        try {
            let parsedUrl = new URL(url);
            let path = parsedUrl.pathname;
    
            let pageParam = parsedUrl.searchParams.get('page');
    
            if (pageParam) {
                path += `?page=${pageParam}`;
            }
    
            return path;
        } catch (error) {
            console.error('Error occurred in getPathWithoutQuery while processing URL:', url);
            console.error(error);            
        }
    }

    function getPrimaryUrl(url) {
        try {
            url = url.toString();
            if (url.includes('/collections/') && url.includes('/products/')) {
                let primary = url.replace(/\/collections\/[^/]+\//, '/');
                return primary;
            }
            return null;
        } catch (error) {
            console.error('Error occurred in getPrimaryUrl while processing URL:', url);
            console.error(error);
        }
    }
    function preloadProductPage(url, source) {
        let path = getPathWithoutQuery(url);
        let primaryPath = getPrimaryUrl(url);
        let cacheTimeout = window.theme.settings.prefetchCachePeriod * 60000; // convert minutes to milliseconds

        if (preloadedHTML[path] && (Date.now() - preloadedHTML[path].timestamp < cacheTimeout)) {
            return;
        }

        fetch(url)
            .then(response => response.text())
            .then(html => {
                preloadedHTML[path] = { html: html, timestamp: Date.now() };
                if (primaryPath) {
                    preloadedHTML[getPathWithoutQuery(primaryPath)] = { html: html, timestamp: Date.now() };
                }
            })
            .catch(error => {
                console.error('Error preloading product page:', error);
            });
    }

    function loadProductPage(url) {
        let path = getPathWithoutQuery(url);
        fetch(url)
            .then(response => response.text())
            .then(html => {
                preloadedHTML[path] = { html: html, timestamp: Date.now() };
                updateContent(html, path, true, false);
            })
            .catch(error => {
                console.error('Error fetching product page:', error);
            });
    }

    function addCurrentPageToPreloadedHTML() {
        let path = getPathWithoutQuery(window.location.href);
        let html = document.documentElement.outerHTML;
        preloadedHTML[path] = { html: html, timestamp: Date.now() };
    }

    function updateContent(html, path, updateHistory = true, replaceState = false) {
        console.log('Prefetch: updateContent called for path:', path);
        let parser = new DOMParser();
        let doc = parser.parseFromString(html, 'text/html');
        let newContent = doc.querySelector('#content > div');
        let newTitle = doc.querySelector('title').innerText;

        if (newContent) {
            console.log('Prefetch: Replacing content');
            document.querySelector('#content > div').replaceWith(newContent);

            if (updateHistory || replaceState) {
                const currentState = history.state && history.state.path;
                if (currentState !== path || replaceState) {
                    if (replaceState) {
                        history.replaceState({ path: path }, '', path);
                    } else {
                        history.pushState({ path: path }, '', path);
                    }
                }
            }

            /*
            Debugging Code
            let variantPickers = document.querySelectorAll('variant-picker');

            variantPickers.forEach((variantPicker) => {
                console.log(variantPicker.constructor.name);
            });
            */

            document.title = newTitle;

            // Hide the Mobile Menu
            document.body.classList.remove("enable-mobile-nav-transition", "reveal-mobile-nav", "reveal-mobile-nav--revealed");

            // Close any open Modal Dialogs
            let modals = document.querySelectorAll('modal-dialog');
            modals.forEach((modal) => {
                modal.close();
            });

            reattachEventListeners();

            // Reset initialization flags for variant-content elements before initializing
            // This is needed because the constructor runs automatically when DOM is replaced
            const variantContents = document.querySelectorAll('variant-content.product-label-list');
            variantContents.forEach(element => {
                delete element.dataset.pillsInitialized;
            });

            // Initialize product label pills after DOM update
            if (typeof window.initializeProductLabelPills === 'function') {
                window.initializeProductLabelPills();
            }

            // Reset and initialize mobile gallery dots
            // Reset the initialization flag first
            const sliders = document.querySelectorAll('.mobile-gallery--dots .slider');
            sliders.forEach(slider => {
                delete slider.dataset.dotsInitialized;
            });
            
            // Initialize mobile gallery dots after a short delay to ensure carousel is ready
            if (typeof window.initMobileGalleryDots === 'function') {
                setTimeout(function() {
                    window.initMobileGalleryDots();
                }, 100);
            }

            window.attachKlaviyoAddToCartListeners();

            gtag('js', new Date());
            gtag('config', 'G-D58M1N2L1J', { 'send_page_view': false });

            console.log('Prefetch: Running initialization scripts');
            runShortReviewScript();
            console.log('Prefetch: About to run review slider script');
            runReviewSliderScript();
            console.log('Prefetch: Review slider script called');

            // If Spend And Save Enabled, update the message to the user
            if (typeof window.updatePDPRewardMessage === 'function') {
                window.updatePDPRewardMessage();
            }

            // If Free Gift Enabled, update the message to the user
            if (typeof window.updatePDPFreeGiftMessage === 'function') {
                window.updatePDPFreeGiftMessage();
            }

            // Initialize star rating click handler for Okendo reviews
            if (typeof window.initStarRatingClickHandler === 'function') {
                window.initStarRatingClickHandler();
            }

            sendViewItemEvent();            

            window.okeWidgetApi.initAllWidgets();

            window.scrollTo(0, 0);

            preloadInitialProductLinks();

            lastReferrer = window.location.href;

            playBackgroundVideo(); 
        }
    }

    function reattachEventListeners() {
        relatedProductsContainer = document.querySelector('cc-fetched-content');
        filterContainer = document.querySelector('div.collection-listing[data-ajax-container]');

        let productLinks = document.querySelectorAll('.product-link');

        productLinks.forEach(function (link) {
            link.addEventListener('click', function (event) {
                event.preventDefault();
                let productUrl = this.href;
                let path = getPathWithoutQuery(productUrl);
                let primaryPath = getPrimaryUrl(productUrl);
                let cacheTimeout = window.theme.settings.prefetchCachePeriod * 60000;

                if (preloadedHTML[path]) {
                    if (Date.now() - preloadedHTML[path].timestamp < cacheTimeout) {
                        updateContent(preloadedHTML[path].html, path, true, false);
                    } else {
                        //console.log(`Cache for ${path} is stale. Reloading the page.`);
                        loadProductPage(productUrl);
                    }
                } else if (primaryPath && preloadedHTML[getPathWithoutQuery(primaryPath)]) {
                    if (Date.now() - preloadedHTML[getPathWithoutQuery(primaryPath)].timestamp < cacheTimeout) {
                        updateContent(preloadedHTML[getPathWithoutQuery(primaryPath)].html, primaryPath, true, false);
                    } else {
                        //console.log(`Cache for ${primaryPath} is stale. Reloading the page.`);
                        loadProductPage(productUrl);
                    }
                } else {
                    loadProductPage(productUrl);
                }
            });
        });

        observeRelatedProducts();
        observeFilterContainer();
    }

    function observeRelatedProducts() {
        let observer;
    
        if (!relatedProductsContainer) return;
    
        observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.addedNodes.length > 0) {
                    if (relatedProductsContainer) {
                        let relatedProductLinks = relatedProductsContainer.querySelectorAll('.product-link');
                        if (relatedProductLinks.length > 0) {
                            relatedProductLinks.forEach(function (link) {
                                let productUrl = link.href;
                                preloadProductPage(productUrl, 'observeRelatedProducts');
                            });
                            reattachEventListeners();
                        }
                    }
                }
            });
        });
    
        observer.observe(relatedProductsContainer, { childList: true, subtree: true });
    }

    function observeFilterContainer() {
        if (!filterContainer) return;

        let observer = new MutationObserver(function (mutations) {
            mutations.forEach(mutation => {
                if (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0) {
                    preloadInitialProductLinks();
                    reattachEventListeners();
                    addCurrentPageToPreloadedHTML();
                }
            });
        });
        observer.observe(filterContainer, { childList: true, subtree: false });
    }

    function preloadInitialProductLinks() {
        let collectionProductLinks = document.querySelectorAll('a.product-link[aria-hidden="true"]');
        collectionProductLinks.forEach(function (link) {
            let productUrl = link.href;
            preloadProductPage(productUrl, 'document');
        });
    }

    window.addEventListener('popstate', function (event) {
        let currentUrl = getPathWithoutQuery(window.location); // Using pathname for consistency   
        let cacheTimeout = window.theme.settings.prefetchCachePeriod * 60000;    
        //console.log('>>> popstate: window.location=' + window.location);
        //console.log('>>>>> popstate: currentUrl=' + currentUrl);
        if (event.state && event.state.path) {
            if (preloadedHTML[currentUrl] && (Date.now() - preloadedHTML[currentUrl].timestamp < cacheTimeout)) {
                updateContent(preloadedHTML[currentUrl].html, currentUrl, false, true);
            } else {
                loadProductPage(window.location);
            }
        } else if (currentUrl === initialUrl) {
            if (preloadedHTML[initialUrl] && (Date.now() - preloadedHTML[initialUrl].timestamp < cacheTimeout)) {
                updateContent(preloadedHTML[initialUrl].html, initialUrl, false, true);
            } else {
                loadProductPage(window.location);
            }
        } else {
            location.reload();
        }
    });

    function runShortReviewScript() {
        const shortReview = document.querySelector('.short-review');
        if (shortReview) {
            const reviewText = shortReview.querySelector('.review-text');
            const moreLink = shortReview.querySelector('.more-link');
            const fullText = reviewText.textContent.trim().replace(/^"(.*)"$/, '$1');
            const words = fullText.split(' ');
            if (words.length > 20) {
                const visibleText = words.slice(0, 20).join(' ');
                reviewText.textContent = visibleText;
                reviewText.classList.add('truncated');
                shortReview.classList.add('truncated');
                moreLink.addEventListener('click', function (e) {
                    e.preventDefault();
                    reviewText.textContent = fullText;
                    reviewText.classList.remove('truncated');
                    moreLink.style.display = 'none';
                });
            }
        }
        
        // Initialize mobile short reviews
        if (typeof window.initializeMobileReviews === 'function') {
            window.initializeMobileReviews();
        }
    }

    function runReviewSliderScript() {
        console.log('Prefetch: runReviewSliderScript started');
        
        // Small delay to ensure DOM is ready
        setTimeout(() => {
            console.log('Prefetch: Looking for review slider container');
            
            // Reset initialization flag to allow re-initialization
            const container = document.querySelector('[data-review-slider]');
            if (container) {
                console.log('Prefetch: Review slider container found, resetting');
                
                // Clear any existing intervals/timeouts
                const existingInterval = container.dataset.intervalId;
                const existingTimeout = container.dataset.timeoutId;
                
                if (existingInterval) {
                    clearInterval(parseInt(existingInterval));
                }
                if (existingTimeout) {
                    clearTimeout(parseInt(existingTimeout));
                }
                
                container.dataset.initialized = 'false';
            } else {
                console.log('Prefetch: No review slider container found');
            }
            
            // Call the global initialization function
            if (typeof window.initReviewSlider === 'function') {
                console.log('Prefetch: Calling window.initReviewSlider');
                window.initReviewSlider();
            } else {
                console.log('Prefetch: window.initReviewSlider not found, retrying...');
                // If function not available yet, try again
                setTimeout(() => {
                    if (typeof window.initReviewSlider === 'function') {
                        console.log('Prefetch: Retry - calling window.initReviewSlider');
                        window.initReviewSlider();
                    } else {
                        console.log('Prefetch: Retry - window.initReviewSlider still not found');
                    }
                }, 100);
            }
            
            // Initialize mobile reviews
            if (typeof window.initializeMobileReviews === 'function') {
                console.log('Prefetch: Calling window.initializeMobileReviews');
                window.initializeMobileReviews();
            } else {
                console.log('Prefetch: window.initializeMobileReviews not found, retrying...');
                // If function not available yet, try again
                setTimeout(() => {
                    if (typeof window.initializeMobileReviews === 'function') {
                        console.log('Prefetch: Retry - calling window.initializeMobileReviews');
                        window.initializeMobileReviews();
                    } else {
                        console.log('Prefetch: Retry - window.initializeMobileReviews still not found');
                    }
                }, 100);
            }
        }, 50);
    }

    function playBackgroundVideo() {
        const videoComponents = document.querySelectorAll('video-component[data-autoplay="true"][data-background="true"]');
        videoComponents.forEach(videoComponent => {
            const videoElement = videoComponent.querySelector('video');
            if (videoElement) {
                videoElement.play().catch(error => {
                    console.error('Error attempting to play the video:', error);
                });
            } else {
                console.error('Video element not found within video component');
            }
        });
    }

    function getProductData() {
        var productDataScript = document.getElementById('product-data');
        if (!productDataScript) return null;

        var productData = JSON.parse(productDataScript.textContent);

        productData.currency = Shopify.currency.active;

        return productData;
    }

    function sendViewItemEvent() {
        var productData = getProductData();

        if (productData) {

            // Klaviyo Viewed Product Event
            var item = {
                Name: productData.item_name,
                ProductID: productData.item_id,
                Categories: [productData.categories],
                ImageURL: productData.imageUrl.replace(/\\u0026/g, '&'),
                URL: window.location.href,
                Brand: productData.item_brand,
                Price: formatPrice(productData.price, productData.currency),
                CompareAtPrice: productData.compare_at_price ? formatPrice(productData.compare_at_price, productData.currency) : formatPrice(0, productData.currency)
            };   
           

            //console.log("item", item);
            
            var _learnq = window._learnq || [];

            // Klaviyo Viewed Product Event
            _learnq.push(['track', 'Viewed Product', item]);
    
            // Klaviyo trackViewedItem Event
            _learnq.push(['trackViewedItem', {
                Title: item.Name,
                ItemId: item.ProductID,
                Categories: item.Categories,
                ImageUrl: item.ImageURL,
                Url: item.URL,
                Metadata: {
                    Brand: item.Brand,
                    Price: item.Price,
                    CompareAtPrice: item.CompareAtPrice
                }
            }]);        

            // GA4 Event
            gtag('event', 'view_item', {
                items: [{
                    id: 'shopify_AU_' + productData.item_id + '_' + productData.variant_id,
                    name: productData.item_name,
                    currency: productData.currency,
                    price: productData.price,
                    brand: productData.item_brand,
                    category: productData.item_category,
                    variant: productData.item_variant
                }],
                ecomm_prodid: 'shopify_AU_' + productData.item_id + '_' + productData.variant_id,
                ecomm_pagetype: 'product',
                page_location: window.location.href,
                page_referrer: lastReferrer
            });

            // Instant Audiences Event
            window.InstantJS.track("PRODUCT_VIEWED", [{
                provider: "KLAVIYO",
                event: {
                    ProductName: productData.item_name,
                    ProductID: productData.item_id,
                    Categories: [productData.item_category],
                    URL: window.location.href,
                    Brand: productData.item_brand,
                    Price: productData.price,
                    CompareAtPrice: productData.compare_at_price || productData.price,  // Assuming compare_at_price might be available in productData
                    ImageURL: productData.imageUrl.replace(/\\u0026/g, '&')  // Assuming featured_image is the field for product image URL
                }
            }]);


            // Meta ViewProduct Event
            // Determine the content type based on the number of variants
            var contentType = (productData.variantCount && productData.variantCount > 1) ? 'product_group' : 'product';
            
            // Meta ViewContent Event
            if (typeof fbq === 'function') {
                fbq('track', 'ViewContent', {
                    content_ids: [productData.item_id],
                    content_name: productData.item_full_name,
                    content_category: productData.item_category,
                    content_type: contentType,
                    value: productData.price,
                    currency: productData.currency
                });
            }

        }
    }

    function formatPrice(price, currency) {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(price);
      }

    addCurrentPageToPreloadedHTML();
    preloadInitialProductLinks();
    reattachEventListeners();
});